<template>
  <div id="yjfk">
    <header class="am-topbar">
      <OffCanvas class="meun">边侧栏</OffCanvas>
      <div class="logo-wrapper">
        <div class="title">意见反馈</div>
      </div>
    </header>
    <div class="wrapper">
      <div class="title">尊敬的客户您好：</div>
      <div class="text">您对我们的新版网站还满意吗？我们很乐意听到您的意见，并会认真对待您的反馈，请您详细描述，以保证管理员及时判断并作出处理。感谢您的关注与支持！</div>
      <div class="title">您觉得不满意的地方(最多300字符)</div>
      <textarea rows="3" v-model="bmy"></textarea>
      <div class="title">您最常用的功能/最关注的功能(最多300字符)</div>
      <textarea rows="3" v-model="cygz"></textarea>
      <div class="title">您觉得需要增加的功能(最多300字符)</div>
      <textarea rows="3" v-model="gnyj"></textarea>
      <div class="title">其他意见(最多300字符)</div>
      <textarea rows="3" v-model="qtyj"></textarea>
      <div class="yzm">
        <input type="text" v-model="yzm" placeholder="输入验证码">
        <img title="点击更换" id="refreshCodeId" onclick="$(this).attr('src', '/imageServlet?t=' + Math.random());"
             src="/imageServlet?t=0.8820587174216004">
        <button type="button" @click="submit">提交反馈</button>
      </div>
    </div>
    <ICP></ICP>
    <alert :showModal.sync="showAlert">{{alertMessage}}</alert>
  </div>
</template>

<script>
  import OffCanvas from '@/components/OffCanvas/OffCanvas'
  import ICP from '@/components/ICP/ICP'
  import alert from '@/components/alert/alert'

  import ajax from '@/common/ajax/ajax'

  export default {
    name: 'yjfk',
    data () {
      return {
        bmy: '',
        cygz: '',
        qtyj: '',
        gnyj: '',
        yzm: '',
        showAlert: false,
        alertMessage: ''
      }
    },
    components: {
      OffCanvas,
      ICP,
      alert
    },
    methods: {
      submit: function () {
        if (!(Boolean(this.bmy) || Boolean(this.cygz) || Boolean(this.qtyj) || Boolean(this.gnyj))) {
          this.alertMessage = '不能提交空内容'
          this.showAlert = true
          return
        }
        let senddata = {
          bmy: this.bmy,
          cygz: this.cygz,
          qtyj: this.qtyj,
          gnyj: this.gnyj,
          yzm: this.yzm
        }
        ajax.yjfk(senddata).then(
          () => {
            this.alertMessage = '恭喜您，提交成功'
            this.showAlert = true
            $('#refreshCodeId').attr('src', '/imageServlet?t=' + Math.random())
          },
          () => {
            $('#refreshCodeId').attr('src', '/imageServlet?t=' + Math.random())
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/common.styl"
  #yjfk
    .wrapper
      padding 0 $bj 0 $bj
      margin-bottom 20px
      .title
        height 15px
        font-size 15px
        margin 10px 0 10px 0
        color $font_color1
        line-height 15px
        font-weight bold
      .text
        font-size 14px
        color $font_color1
        text-indent: 2em;
        margin-bottom 24px
      textarea
        width 100%
        margin 11px 0 23px 0
      button
        color #fff
        font-size 17px
        height 40px
        width 100%
        border 0
        background-color $color1
        border-radius 5px
      .yzm
        img
          margin 10px 13px 16px 13px
        input
          margin 10px 0 16px 0
          height 40px
          padding-left 13px
          width 160px
          height 40px
          border-radius 5px
          color $font_color1
          font-size $font_size1


</style>



// WEBPACK FOOTER //
// yjfk.vue?c2747704